// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"AboutUs_conteiner__1U3cn"};